import {useState,React} from 'react';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Certificates from './components/Certificates';
import Education from './components/Education';
import Patents from './components/Patents';
import Achievements from './components/Achievements';
import WorkExperience from './components/WorkExperience';
import Hobbies from './components/Hobbies';
import Footer from './components/Footer';
import Homepage from './components/homepage';
import { BrowserRouter as Router,Switch, Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Flower from './components/flower';
import TypingText from './components/TypingText';
import CircularMenu from './components/CircularMenu';
import BottomBar from './components/BottomBar';
import Skills from './components/Skills';
import SkillsList from './components/SkillsList';
import ImageCarousel from './components/ImageCarousel';
import CardSlider from './components/CardSlider';
// const images = [
//   './postman.png',
//   './aws1.png',
//   './aws2.png',
//   './block.png',
//   './oracle.png',
//   './witty.png',
//   './codsoft.png',
//   './androidi.png',
//   './datai.png',
//   './zscaler.png',
//   './aimli.png',
//   './o1i.png',
//   './goo1.png',
//   './goo2.png',


// ];
const images = [
  { src: './postman.png', name: 'Postman API Student Expert', certificateLink: 'https://badgr.com/public/assertions/uHwHhA-nRQuB52ifEkQfpQ?identity__email=gampawarsc@rknec.edu' },
  { src: './aws1.png', name: 'AWS Academy Cloud Foundations', certificateLink: 'https://www.credly.com/badges/f87f964e-7723-48b0-9ee2-7cf2e979cb56/print' },
  { src: './aws2.png', name: 'AWS Academy Data Analytics', certificateLink: 'https://www.credly.com/badges/4b68e412-d20f-4b62-b453-54caa5dcd092/print' },
  { src: './block.png', name: 'Blockchain Fundamentals', certificateLink: 'https://courses.edx.org/certificates/6828b6ce65cd4bdc964486aa2dd73e67' },
  { src: './oracle.png', name: 'Oracle Gen AI Proffesional', certificateLink: 'https://drive.google.com/file/d/17zVLQSrsBvc41a1yCG2acEfGJaM28z-m/view?usp=sharing' },
  { src: './witty.png', name: 'WittyHacks 4.0', certificateLink: 'https://drive.google.com/file/d/1MyQpn1pn4roTjMdzVW9j5iQOkp6C4KkW/view?usp=sharing' },
  { src: './codsoft.png', name: 'Codsoft Virtual Internship', certificateLink: 'https://drive.google.com/file/d/1yuHvAbMnAYc55pBmSXcZ3qul-Xip2vX6/view?usp=sharing' },
  { src: './androidi.png', name: 'Android Virtual Internship', certificateLink: 'https://drive.google.com/file/d/1JdYzPlWmEa_TlOJtlW8RkGiTfBiqjRuL/view?usp=sharing' },
  { src: './datai.png', name: 'Data Analytics Virtual Internship', certificateLink: 'https://drive.google.com/file/d/1D3ctuPCafa3AiANi015iqS2QmvQMPICj/view?usp=sharing' },
  { src: './zscaler.png', name: 'Zscaler Virtual Internship', certificateLink: 'https://drive.google.com/file/d/1G17e54RwWU4eA3le73Me2JcVJEOQ0N9k/view?usp=sharing' },
  { src: './aimli.png', name: 'AIML Virtual Internship', certificateLink: 'https://drive.google.com/file/d/1lfcqPIhhY8NYBvNwiiZPsuPNv5oWUTe1/view?usp=sharing' },
  { src: './o1i.png', name: 'O(1) Coding Club Internship', certificateLink: 'https://drive.google.com/file/d/1ngLNRQ-vVzZSvxYR3reyCcbnVHlMn2cR/view' },
  { src: './goo1.png', name: 'Google Analytics for Beginners', certificateLink: 'https://drive.google.com/file/d/1NmN0axiO8wVzlZ8c89MqrsYbs8fAjLGO/view?usp=sharing' },
  { src: './goo2.png', name: 'Advanced Google Analytics', certificateLink: 'https://drive.google.com/file/d/1sBQubPnevy03TG-hpp1X-znvwpeoUcuy/view?usp=sharing' }
];

const Portfolio = () => {
    const projects = [
        { title: 'Project 1', description: 'Description of Project 1...' },
        { title: 'Project 2', description: 'Description of Project 2...' }
    ];

    const patents = [
        { title: 'Patent 1', description: 'Description of Patent 1...' },
        { title: 'Patent 2', description: 'Description of Patent 2...' }
    ];

    const achievements = [
        { title: 'Achievement 1', description: 'Description of Achievement 1...' },
        { title: 'Achievement 2', description: 'Description of Achievement 2...' }
    ];

    const workExperiences = [
        { company: 'Company 1', position: 'Position 1', description: 'Description of Work Experience 1...' },
        { company: 'Company 2', position: 'Position 2', description: 'Description of Work Experience 2...' }
    ];

    const hobbies = [
        { title: 'Hobby 1', description: 'Description of Hobby 1...' },
        { title: 'Hobby 2', description: 'Description of Hobby 2...' }
    ];
    const educationData = [
      {
        year: '2021 - 2025',
        title: 'BTech - Computer Science and Engineering (Data Science)',
        institution: 'Shri Ramdeobaba College of Engineering and Management',
        grade: 'CGPA - 10',
      },
      {
        year: '2021',
        title: 'HSC',
        institution: 'G.H. Raisoni Vidyaniketan, Nagpur',
        grade: '81.8 %',
      },
      {
        year: '2019',
        title: 'SSC',
        institution: 'Podar International School, Nagpur',
        grade: '93.6 %',
      },
      // Add more items as needed
    ];


    return (
        <div style={getStyle()}>
        <div>
            {/* <Header />
            <About aboutText="Welcome to my portfolio! I'm a passionate developer..." />
            <Projects projects={projects} />
            <Patents patents={patents} />
            <Achievements achievements={achievements} />
            <WorkExperience experiences={workExperiences} />
            <Hobbies hobbies={hobbies} />
            <Footer /> */}
            {/* <Homepage />
            <Footer /> */}
        <Router>
            {/* <Routes>
                <Route exact path="/" component={Homepage} />
                <Route path="/Projects" component={Projects} />
                <Route path="/" element={<Homepage />} />
                <Route path="/Projects" element={<Projects />} />
            </Routes> */}
            {/* <div>
              <Link to="/footer">Footer</Link>
              <Link to="/header">Header</Link>
              <Link to="/homepage">Home</Link>
              <Link to="/Flower">Flower</Link>

            </div> */}
        {/* </Router>
        <Router> */}
        <Routes>
            {/* <Route path="/footer" exact>
                <Footer />
            </Route> */}
            <Route path="/" element={<Homepage />} />
            <Route path="/footer" element={<Footer />} />
            <Route path="/header" element={<Header />} />
            <Route path="/About" element={<About />} />
            <Route path="/Flower" element={<Flower />} />
            <Route path="/Projects" element={<Projects />} />
            <Route path="/WorkExperience" element={<WorkExperience />} />
            <Route path="/Certificates" element={<Certificates />} />
            <Route path="/Education" element={<Education educationData={educationData} />} />
            <Route path="/Achievements" element={<Achievements />} />
            <Route path="/Patents" element={<Patents />} />
            <Route path="/Skills" element={<Skills />} />
            {/* <Route path="/SkillsList" element={<SkillsList />} /> */}
            {/* <Route path="/VideoPlayer" element={<VideoPlayer 
        url="https://www.youtube.com/watch?v=dQw4w9WgXcQ" 
        thumbnail="https://img.youtube.com/vi/dQw4w9WgXcQ/0.jpg" 
      />} /> */}
      <Route path="/CircularMenu" element={<CircularMenu />} />
      <Route path="/ImageCar" element={<ImageCarousel images={images} />} />
      <Route path="/CardSlider" element={<CardSlider images={images} />} />
            {/* <Route path="/header" exact>
                <Header />
            </Route> */}
        </Routes>
        {/* <Homepage /> */}
        <BottomBar />

    {/* <CircularMenu /> */}
        </Router>
        </div>
        </div>
    );
};

function getStyle() {
    const screenWidth = window.innerWidth;
    let style = {};
  
    if (screenWidth < 768) {
      style = {
        /* Styles for smaller screens */
      };
    } else if (screenWidth >= 768 && screenWidth < 1024) {
      style = {
        /* Styles for medium screens */
      };
    } else {
      style = {
        /* Styles for larger screens */
      };
    }
  
    return style;
  }

export default Portfolio;
